export class AbstractStore<S> implements AltJS.StoreModel<S> {
    bindListeners: (obj: any) => void;
    exportPublicMethods: (config: { [key: string]: (...args: Array<any>) => any }) => any;
    exportAsync: (source: any) => void;
    waitFor: (storeOrStores: AltJS.AltStore<any> | Array<AltJS.AltStore<any>>) => void;
    on: (event: AltJS.lifeCycleEvents, callback: () => any) => void;
    exportConfig: any;
    getState: () => S;
    dispatcher: any;

}


// WEBPACK FOOTER //
// ./src/app/store/AbstractStore.ts